module.exports = __webpack_public_path__ + "img/warm.d9384b8d.webp";